<template>
    <div v-if="form && model">
        <rkm-area no-margin-top title="filtros" type="fieldset">
            <rkm-form ref="Form" show-legend>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            v-model="model.periodo"
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            range
                            :start-validations="{ required: true }"
                            :end-validations="{ required: true }"
                        />
                    </rkm-col>
                    <rkm-col cols="3">
                        <rkm-form-select
                            label="Unidade"
                            :options="form.unidades"
                            v-model="model.unidadeId"
                            show-default-option
                            default-option-text="Todas"
                            text-field="nomeFantasia"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col cols="3">
                        <rkm-form-select
                            label="Código da equipe"
                            :options="form.equipes"
                            v-model="model.equipeId"
                            show-default-option
                            default-option-text="Todas"
                            text-field="id"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col cols="1">
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="search"
                        >
                            Buscar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="items.length"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
            <rkm-table
                :fields="fields"
                :items="items"
                hide-filters
                hide-pagination
                no-footer-sorting
            ></rkm-table>
        </rkm-area>

        <rkm-area
            title="Total"
            no-margin-top
            class="mt-2"
            v-if="total"
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-alert color="secondary">
                        <b>
                            {{ total }}
                        </b>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
import { repository, error, data, object, stringCase, file } from "@/mixins";
import { mapActions } from "vuex";
import moment from "moment";

export default {
    created() {
        this.repositories = {
            relatorioAtendimentoOdontologico: this.getConectaSusRepository("atencaoBasica.relatorioAtendimentoOdontologico"),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
        }
        this.load()
    },
    computed: {
        fields() {
            return [
                {
                    key: "primeiraConsultaOdontologica",
                    label: "1ª Consulta Odontológica Programática",
                    fixed: true,
                },
                {
                    key: "escovacaoDentalSupervisionada",
                    label: "Escovação Dental Supervisionada",
                    fixed: true,
                },
                {
                    key: "tratamentoConcluido",
                    label: "Tratamento Concluído",
                    fixed: true,
                },
                {
                    key: "urgencia",
                    label: "Urgência",
                    fixed: true,
                },
                {
                    key: "gestante",
                    label: "Gestante",
                    fixed: true,
                },
                {
                    key: "instalacaoProtesesDentarias",
                    label: "Instalação de Próteses Dentárias",
                    fixed: true,
                },
            ]
        }
    },
    data() {
        return {
            form: null,
            model: null,
            items: [],
            total: null
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading()
            this.repositories.relatorioAtendimentoOdontologico.index()
                .then(({data}) => {
                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            this.$refs.Form.validate().then(valid => {
                if(!valid) return
                this.setLoading()
                this.repositories.relatorioAtendimentoOdontologico.list({
                    data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                    data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                    unidade_id: this.model.unidadeId,
                    equipe_id: this.model.equipeId,
                })
                    .then(({data}) => {
                        this.items = [data]
                        this.total = data.totalAtendimentosOdontologicos
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            })
        },
        getUnidades() {
            this.setLoading()
            this.repositories.relatorioAtendimentoOdontologico.getUnidades({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
            })
                .then(({data}) => {
                    this.form.unidades = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {
            this.setLoading()
            this.repositories.relatorioAtendimentoOdontologico.getEquipes({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                unidade_id: this.model.unidadeId
            })
                .then(({data}) => {
                    this.form.equipes = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        print() {
            this.setLoading()
            this.repositories.impressao.relatorioAtendimentoOdontologico(this.prepareData())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()
            this.repositories.exportacao.relatorioAtendimentoOdontologico(this.prepareData())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {
            const data = this.clone(this.model)
            data.data_inicial = moment(data.periodo.start).format('YYYY-MM-DD')
            data.data_final = moment(data.periodo.end).format('YYYY-MM-DD')
            return this.camelObjectKeysToSnakeRecursive(data)
        }
    },
    watch: {
        'model.periodo.start' () {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getUnidades()
            }
        },
        'model.periodo.end' () {
            if(this.model.periodo.end && this.model.periodo.start) {
                this.getUnidades()
            }
        },
        'model.unidadeId' () {
            if(this.model.unidadeId) {
                this.getEquipes()
            }
        }
    },
    mixins: [ repository, error, data, object, stringCase, file ]
}
</script>